export default {"src":"/_next/static/media/deco_checkout_amex.16ab1605.svg","height":34,"width":55,"blurWidth":0,"blurHeight":0};